// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"056a9228","554":"969880f9","742":"86573eb5","761":"31e8ab78","822":"a244dcdf","831":"2c6ae05f","834":"c897342a"}[chunkId] + ".chunk.css";
};